import { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { WifiSlash, CloudArrowUp } from "@phosphor-icons/react";
import { countQueued, replayQueue } from "../lib/api";

export default function OfflineBanner() {
  const { t } = useTranslation();
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const [pending, setPending] = useState(0);

  const refresh = useCallback(async () => {
    setPending(await countQueued());
  }, []);

  useEffect(() => {
    const up = async () => {
      setOnline(true);
      const r = await replayQueue();
      if (r.synced > 0 || r.failed > 0) refresh();
    };
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    refresh();
    const poll = setInterval(refresh, 5000);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
      clearInterval(poll);
    };
  }, [refresh]);

  if (online && pending === 0) return null;

  if (!online) {
    return (
      <div className="bg-amber-50 border-b border-amber-200 text-amber-900 text-xs px-4 py-2 flex items-center gap-2" data-testid="offline-banner" role="alert">
        <WifiSlash size={14} weight="bold"/>
        <span>{t("app.offline")}</span>
        {pending > 0 && <span className="ml-auto font-mono-eos">{pending} queued</span>}
      </div>
    );
  }

  return (
    <div className="bg-indigo-50 border-b border-indigo-200 text-indigo-900 text-xs px-4 py-2 flex items-center gap-2" data-testid="sync-banner" role="status">
      <CloudArrowUp size={14} weight="bold" className="animate-pulse"/>
      <span>{t("common.syncing", { count: pending })}</span>
    </div>
  );
}
